export default __webpack_public_path__ + "static/media/trainers.6c644df4.svg";